import { Award, Building2, Globe2, Layers } from "lucide-react";
import { CountUp } from "@/components/CountUp";
import { STATS } from "@/lib/site";

export default function HeroStats() {
  return (
    <div className="hero-stats-gap mt-12 md:mt-16 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-4xl">
      {STATS.map((s, idx) => {
        const num = parseFloat(s.value.replace(/[^0-9.]/g, "")) || 0;
        const suffix = s.value.replace(/[0-9.]/g, "");

        const Icons = [Award, Building2, Globe2, Layers];
        const Icon = Icons[idx] || Award;

        return (
          <div
            key={s.label}
            data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="stat-glass group"
          >
            <div className="relative flex items-center justify-between">
              <div className="hero-stat-num font-display text-2xl md:text-[36px] text-white tabular-nums font-light leading-none">
                <CountUp end={num} suffix={suffix} />
              </div>

              <div className="w-9 h-9 rounded-lg bg-stenzia-gold/15 text-stenzia-gold flex items-center justify-center border border-stenzia-gold/25 group-hover:bg-stenzia-gold group-hover:text-charcoal transition-all duration-500">
                <Icon size={16} />
              </div>
            </div>

            <div className="relative text-[9px] md:text-[10px] mt-3 md:mt-4 text-white/65 tracking-[0.22em] uppercase font-medium">
              {s.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}